import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { PatientProcedure } from '@/types/patient-chart-api';

/**
 * Patient procedures list — Chart > Procedures tab (PROD-736 PR C).
 *
 * Wire (Flutter `patient_chart_data_source_impl.dart:684`):
 *
 *   GET /api/Patients/GetProcedureByPatientId?PatientId={id}
 *       → PatientProcedure[]
 *
 * Flat array; tombstones (`isDeleted: true`) included and filtered
 * client-side, same pattern as Allergies + Problems.
 */

export function usePatientProcedures(patientId: string | null | undefined) {
  return useQuery({
    queryKey: ['patient-procedures', patientId],
    queryFn: ({ signal }) => {
      const qs = new URLSearchParams({ PatientId: patientId ?? '' });
      return get<PatientProcedure[]>(
        `/api/Patients/GetProcedureByPatientId?${qs.toString()}`,
        { signal },
      );
    },
    enabled: !!patientId,
    staleTime: 60_000,
  });
}
